import {
  faAngleDown,
  faAngleRight,
  faCalendarDays,
  faCheck,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, DatePicker, Dropdown, Space } from "antd";
import moment from "moment";
import { useState } from "react";
import styles from "./dashboard.module.scss";

const { RangePicker } = DatePicker;

const DashboardMenu: React.FC<{ setFilters: any }> = ({ setFilters }) => {
  const [visible, setVisible] = useState(false);
  const [panelVisible, setPanelVisible] = useState(false);
  const [labelText, setLabelText] = useState("Month to Date");
  const [selectedKey, setSelectedKey] = useState("mtd");
  const now = moment();

  const disabledDate = (current: any, info?: { from?: any }) => {
    if (current && current > now.endOf("day")) {
      return true;
    }
    if (info?.from) {
      return Math.abs(current.diff(info.from, "years", true)) >= 1;
    }
    return false;
  };

  const renderLabel = (text: string, key: string) => (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        width: "100%",
      }}
    >
      <span>{text}</span>
      {selectedKey === key && (
        <FontAwesomeIcon icon={faCheck} style={{ color: "#249AF3" }} />
      )}
    </div>
  );

  const items: any = [
    {
      key: "today",
      label: renderLabel("Today", "today"),
      onClick() {
        setFilters([
          [now.format("MM/DD/YYYY"), now.format("MM/DD/YYYY")],
          "today",
        ]);
        setSelectedKey("today");
        setVisible(false);
        setPanelVisible(false);
        setLabelText("Today");
      },
    },
    {
      key: "mtd",
      label: renderLabel("Month to Date", "mtd"),
      onClick() {
        if (selectedKey === "mtd") { setVisible(false); return; }
        const startOfMonth = moment().startOf("month");
        setFilters([
          [startOfMonth.format("MM/DD/YYYY"), now.format("MM/DD/YYYY")],
          "mtd",
        ]);
        setSelectedKey("mtd");
        setVisible(false);
        setPanelVisible(false);
        setLabelText("Month to Date");
      },
    },
    {
      key: "last30",
      label: renderLabel("Last 30 Days", "last30"),
      onClick() {
        if (selectedKey === "last30") { setVisible(false); return; }
        const startDate = moment().subtract(30, "days");
        setFilters([
          [startDate.format("MM/DD/YYYY"), now.format("MM/DD/YYYY")],
          "last30",
        ]);
        setSelectedKey("last30");
        setVisible(false);
        setPanelVisible(false);
        setLabelText("Last 30 Days");
      },
    },
    {
      key: "lastMonth",
      label: renderLabel("Previous Month", "lastMonth"),
      onClick() {
        if (selectedKey === "lastMonth") { setVisible(false); return; }
        const startDateOfLastMonth = moment()
          .subtract(1, "month")
          .startOf("month");
        const endDateOfLastMonth = moment().subtract(1, "month").endOf("month");
        setFilters([
          [
            startDateOfLastMonth.format("MM/DD/YYYY"),
            endDateOfLastMonth.format("MM/DD/YYYY"),
          ],
          "lastMonth",
        ]);
        setSelectedKey("lastMonth");
        setVisible(false);
        setPanelVisible(false);
        setLabelText("Previous Month");
      },
    },
    {
      key: "ytd",
      label: renderLabel("Year to Date", "ytd"),
      onClick() {
        if (selectedKey === "ytd") { setVisible(false); return; }
        const startOfYear = moment().startOf("year");
        setFilters([
          [startOfYear.format("MM/DD/YYYY"), now.format("MM/DD/YYYY")],
          "ytd",
        ]);
        setSelectedKey("ytd");
        setVisible(false);
        setPanelVisible(false);
        setLabelText("Year to Date");
      },
    },
    { type: "divider" },
    {
      key: "custom-date",
      label: (
        <div
          style={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%" }}
          onClick={(e) => {
            e.stopPropagation();
            setPanelVisible(true);
          }}
        >
          <span>Custom</span>
          <FontAwesomeIcon icon={faAngleRight} style={{ color: "#CCCFD3", paddingRight: '8px' }} />
        </div>
      ),
    },
  ];

  return (
    <>
    <Dropdown
      rootClassName={styles.dashboardMenu}
      arrow={false}
      open={visible}
      trigger={["click"]}
      destroyOnHidden
      onOpenChange={(open) => {
        if(panelVisible){
          return;
        }
        setVisible(open);
        if (!open) {
          setPanelVisible(false);
        }
      }}
      menu={{
        items,
        selectedKeys: [selectedKey],
      }}
    >
      <Button className={styles.dateButton}>
        <Space>
          <span>
            <FontAwesomeIcon icon={faCalendarDays} />
          </span>
          <span>{labelText}</span>
          <span>
            <FontAwesomeIcon icon={faAngleDown} style={{color: '#000000', opacity: '25%', paddingRight: '4px'}}/>
          </span>
        </Space>
      </Button>
    </Dropdown>
    <div
      onClick={(e) => {
        e.stopPropagation();
      }}
    >
      <RangePicker
        popupClassName="custom-range-picker"
        open={panelVisible}
        styles={{
          root: {
            pointerEvents: "none",
            opacity: 0,
            position: "absolute",
            top: 3
          },
        }}
        format="MM/DD/YYYY"
        disabledDate={disabledDate}
        onOpenChange={(open) => {
          if (!open) {
            setPanelVisible(false);
            setVisible(false);
          }
        }}
        onChange={(ranges, dateStrings) => {
          if (dateStrings?.[0] && dateStrings?.[1]) {
            setFilters([[dateStrings[0], dateStrings[1]], ""]);
            setSelectedKey("custom-date");
          } else {
            setFilters(null);
          }
          setVisible(false);
          setPanelVisible(false);
          setLabelText("Custom");
        }}
      />
    </div>
    </>
  );
};

export default DashboardMenu;
